const DEV_HOST_REWRITES: ReadonlyArray<readonly [from: string, to: string]> = [
  ['http://localhost:3000', 'https://spark.local'],
  ['http://localhost:9023', 'https://spark.local'],
]

export function resolveDevAssetUrl(url: string): string {
  if (!import.meta.env.DEV || import.meta.env.VITE_USE_HTTP) return url
  return DEV_HOST_REWRITES.reduce((acc, [from, to]) => acc.replace(from, to), url)
}
